<template>
    <div class="layout-sidebar overflow-auto">
        <div class="flex items-center justify-center px-6 pt-10 sm:pb-8">
            <div class="flex flex-col items-center gap-6">
                <nuxt-link
                    :to="
                        viewer !== undefined
                            ? facilityHomeLink(viewer.homeFacility.slug)
                            : orgHomeLink()
                    "
                    class="app-logo"
                >
                    <img
                        :src="
                            activeFacility.branding.logo ??
                            activeFacility.organization.logo
                        "
                        :alt="viewer?.homeFacility.shortName"
                        class="max-h-[10rem]"
                    />
                </nuxt-link>

                <nuxt-link
                    v-if="viewer !== undefined && !isKiosk"
                    :to="facilityHomeLink(viewer.homeFacility.slug)"
                    class="ml-4 flex items-center gap-2 whitespace-nowrap rounded px-6 py-3 text-center font-semibold text-gray-600 hover:bg-gray-200"
                >
                    <i class="pi pi-home" />
                    {{ viewer.homeFacility.shortName }}
                </nuxt-link>
            </div>
        </div>

        <div class="mb-12 flex-1 pb-8">
            <app-menu />
        </div>
    </div>
</template>

<script setup lang="ts">
import AppMenu from './AppMenu.vue'
import { useViewer } from '~/composables/use-login'
import { useRouteLink } from '~/composables/routing'
import NuxtLink from '#app/components/nuxt-link'
import { useActiveFacility } from '~/composables/use-active-facility'
import { useLayoutMode } from '~/composables/use-layout-mode'

const { isKiosk } = useLayoutMode()
const viewer = useViewer()
const { orgHomeLink, facilityHomeLink } = useRouteLink()
const activeFacility = useActiveFacility()
</script>
